










































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import CardContainer from "@/components/CardContainer.vue";
import CartSummary from "@/components/CartSummary.vue";
import SummaryLine from "@/components/SummaryLine.vue";
import PaymentMethods from "@/components/PaymentMethods.vue";
import OrderConfirmation from "@/components/OrderConfirmation.vue";
import TimeSlotSelect from "@/components/TimeSlotSelect.vue";
import AddressBlock from "@/components/AddressBlock.vue";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { Route, NavigationGuardNext } from "vue-router";
import { checkoutPaymentStarted, isWishope } from "@/common/utils";
import { ROUTES_MAP } from "@/router";
import Checkbox from "@/components/Checkbox.vue";
import Store from "@/store";
import GTMService from "@/services/GTMService";

const VasPaymentProps = Vue.extend({
  computed: {
    ...mapState("global", ["cart", "checkout"]),
    ...mapState("vas", ["shopMenu", "merchantShopDetails", "selectedTimeslot"]),
    ...mapGetters("vas", [
      "merchant",
      "hasDelivery",
      "getDeliverySlots",
      "hasTimeSlotDelivery",
      "hasEcommerceDelivery",
      "isEnabled",
      "isShowPoliticalMessage",
      "shippingDeliveryCost"
    ]),
    grandTotal() {
      // return this.cart.totals.grandTotal;
      // Problema del calcolo a BE che è stato risolto spostando il calcolo a FE.
      return this.cart.totals.finalSellingPrice + parseFloat((this.shippingDeliveryCost / 100).toFixed(2));
    },
    subtotal() {
      return this.cart.totals.finalSellingPrice;
    },
    shippingTotal() {
      return  Number(this.shippingDeliveryCost / 100).toFixed(2);
    },
  },
  methods: {
    ...mapMutations("vas", []),
    ...mapActions("vas", ["fetchMenu", "setShippingTimeSlot"]),
    ...mapActions("global", ["resetCheckout"]),

    getIsVasOrderAndPay() {
      return this.cart.vasType == 'ORDER_AND_PAY';
    },

    isWishope,
  },
});

Component.registerHooks(["beforeRouteEnter"]);

@Component({
  components: {
    Checkbox,
    SummaryLine,
    CardContainer,
    TimeSlotSelect,
    CartSummary,
    AddressBlock,
    OrderConfirmation,
    PaymentMethods,
  },
})
export default class VasPayment extends VasPaymentProps {
  acceptsTerms: boolean = false;
  selectedPayment!: string;

  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
    if (
      Store.state.global.checkout &&
      checkoutPaymentStarted(Store.state.global.checkout)
    ) {
      return next();
    }
    if (
      (Store.state.global.checkout ||
        Store.getters["vas/hasValidAddressAndShipping"]) &&
      Store.state.global.cart &&
      Store.state.global.cart.products &&
      Store.state.global.cart.products.length
    ) {
      return next();
    } else {
      return next({ name: ROUTES_MAP.VAS_PRODUCTS, params: to.params });
    }
  }

  editAddress() {
    this.$router.push({
      name: ROUTES_MAP.VAS_ADDRESS,
      params: this.$route.params,
    });
  }

  handleTimeSlot(timeslot: TimeSlot) {
    // this.setShippingTimeSlot(timeslot);
  }

  onSelectedPayment(payment : any)
  {
    this.selectedPayment = payment;
  }

  created() {

    GTMService.dataLayerCheckoutStep2(this.cart, this.merchant);

    if (
      this.cart &&
      this.checkout &&
      !this.checkout.description.includes(this.cart.id)
    ) {
      // this.resetCheckout();
    }
  }
}
